import NewPassword from './new-password.vue';

export default NewPassword;
